import { useMemo } from "react";
import Modal from "./Modal";
import { useVisible } from "../../../../../utils/hooks/useVisible";

export const useImportLogModal = ({ onSuccess }) => {
    const { visible, open, close } = useVisible();

    const modal = useMemo(() => visible && (
        <Modal
            visible={visible}
            close={close}
            onSuccess={onSuccess}
        />
    ), [close, onSuccess, visible]);

    return { open, modal };
}
